import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import AddMoreDataButton from '../../../../components/addMoreDataButton/AddMoreDataButton';
import RemovableItem from '../../RemovableItem/RemovableItem';

import editDocumentActions from '../../store/actions/edit-document.actions';
import documentEditMode from '../../constants/documentEditMode';

import styles from '../table.module.scss';
import roles from '../../constants/roles';
import useUserRoleInDoc from '../../hooks/useUserRoleInDoc';

const ContractorCell = memo(({ record, rowOpened }) => {
  const dispatch = useDispatch();
  const userRole = useUserRoleInDoc(record);
  // const allowChange = userRole === roles.RESPONSIBLE_OR_AUTHOR;

  const handleAddContractor = useCallback(
    (e) => {
      e.stopPropagation();
      dispatch(
        editDocumentActions.openModal({
          ...record,
          editMode: documentEditMode.CONTRACTOR,
        })
      );
    },
    [record]
  );

  const type = record.type && record.type.id;
  if (!type) {
    return null;
  }
  const orgs =
    type == 2
      ? [
          {
            orgName: record.org && record.org.name,
            orgInn: record.org && record.org.inn,
            orgId: record.org && record.org.id,
            inNumber: record.inNumber,
          },
        ]
      : type === 1 || type === 4
      ? record.attachOrg
      : null;

  return (
    <div className={styles.additionalInfo}>
      <h4 className={styles.additionalInfoTitle}>Адресат</h4>
      {!record.counterpartyOwners?.length && (
        <span className={styles.tdItem}>Нет данных</span>
      )}
      {
        <>
          <ul className={styles.additionalInfoList}>
            {record.counterpartyOwners?.map((client) => (
              <li
                key={client.id}
                className={styles.additionalInfoItem}
              >
                <RemovableItem
                  record={record}
                  itemText={client.clientName}
                  deleteConfirmText="Удалить адресата?"
                  onConfirm={() =>
                    dispatch(editDocumentActions.deleteClient(client.id))
                  }
                  allowDelete={false}
                />
              </li>
            ))}
            {/* {orgs &&
              orgs.map((org) => {
                if (!org.orgName) {
                  return null;
                }

                return (
                  <li
                    key={org.orgId}
                    className={styles.additionalInfoItem}
                  >
                    <div className={styles.additionalInfoRow}>
                      <span className={styles.tdItem}>{org.orgName}</span>
                    </div>
                    <div className={styles.additionalInfoRow}>
                      <span
                        style={{ opacity: 0.5 }}
                        className={styles.tdItem}
                      >
                        ИНН:
                      </span>{' '}
                      <RemovableItem
                        record={record}
                        showDelete={false}
                        itemText={org.orgInn || 'Пусто'}
                        lastWordStyle={{ color: '#09a2f2' }}
                        deleteConfirmText="Удалить адресата?"
                        onConfirm={() =>
                          dispatch(
                            editDocumentActions.deleteOrgFromDoc(
                              record.id,
                              org.orgId
                            )
                          )
                        }
                        allowDelete={false}
                      />
                    </div>
                  </li>
                );
              })} */}
          </ul>
          {/* <AddMoreDataButton
            text={'Добавить адресата'}
            onClick={handleAddContractor}
          /> */}
        </>
      }
    </div>
  );
});

export default ContractorCell;
